import { Observable, Subject, combineLatest } from "rxjs";
import { USERINPUTTYPE } from "./internal";
import { map } from "rxjs/operators";
/**
 * @class UserInputWrapper
 *
 * @classdesc Provides methods for access the User Input Handler.
 */
export class UserInputWrapper {
    constructor(_userinputhandler) {
        this._userinputhandler = _userinputhandler;
        this._notifyZoomChanged$ = new Subject();
        this._notifyPanChanged$ = new Subject();
        this.geoframecollectionchanged$.subscribe((geoframecollection) => {
            geoframecollection.imagequadtree.onZoom = (zoom) => {
                this._notifyZoomChanged$.next(zoom);
            };
            geoframecollection.imagequadtree.onPan = (panX, panY) => {
                this._notifyPanChanged$.next([panX, panY]);
            };
        });
    }
    get geoframechanged$() {
        return this._wrapUserInput$(USERINPUTTYPE.GEOFRAMECHANGED);
    }
    get buffering$() {
        return this._wrapUserInput$(USERINPUTTYPE.BUFFERING);
    }
    get tileloading$() {
        return this._wrapUserInput$(USERINPUTTYPE.TILE_LOADING);
    }
    get geoframecollectionchanged$() {
        return this._wrapUserInput$(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED);
    }
    get panorotationchanged$() {
        return new Observable((subscriber) => {
            const evt = this._userinputhandler.subscribeEvent(USERINPUTTYPE.PANO_ROTATION, (lat, lon, fov) => {
                subscriber.next({
                    type: "pano",
                    lat: lat,
                    lon: lon,
                    fov: fov,
                });
            }, this);
            return () => {
                this._userinputhandler.unSubscribeEvent(USERINPUTTYPE.PANO_ROTATION, evt);
            };
        });
    }
    get panzoomchanged$() {
        return combineLatest([this._notifyZoomChanged$, this._notifyPanChanged$]).pipe(map(([zoom, [panX, panY]]) => {
            return {
                type: "panzoom",
                zoom: zoom,
                panX: panX,
                panY: panY,
            };
        }));
    }
    get navigationaxischanged$() {
        return this._wrapUserInput$(USERINPUTTYPE.NAVIGATION_AXISCHANGED);
    }
    get measurementaxischanged$() {
        return this._wrapUserInput$(USERINPUTTYPE.MEASUREMENT_AXISCHANGED);
    }
    get measuremodechanged$() {
        return this._wrapUserInput$(USERINPUTTYPE.MEASUREMODE_CHANGED);
    }
    get layerchanged$() {
        return this._wrapUserInput$(USERINPUTTYPE.LAYERCHANGED);
    }
    get layeradded$() {
        return this._wrapUserInput$(USERINPUTTYPE.LAYERADDED);
    }
    get layerremoved$() {
        return this._wrapUserInput$(USERINPUTTYPE.LAYERREMOVED);
    }
    get layerupdated$() {
        return this._wrapUserInput2$(USERINPUTTYPE.LAYERUPDATED);
    }
    get layersaved$() {
        return this._wrapUserInput4$(USERINPUTTYPE.LAYERSAVED);
    }
    get featureselected$() {
        return this._wrapUserInput2$(USERINPUTTYPE.FEATURESELECTED);
    }
    get featuredeselected$() {
        return this._wrapUserInput2$(USERINPUTTYPE.FEATUREDESELECTED);
    }
    _wrapUserInput$(userinputtype) {
        return new Observable((subscriber) => {
            const evt = this._userinputhandler.subscribeEvent(userinputtype, (value) => {
                subscriber.next(value);
                /* subscriber.complete(); */
            }, this);
            return () => {
                this._userinputhandler.unSubscribeEvent(userinputtype, evt);
            };
        });
    }
    _wrapUserInput2$(userinputtype) {
        return new Observable((subscriber) => {
            const evt = this._userinputhandler.subscribeEvent(userinputtype, (value1, value2) => {
                subscriber.next([value1, value2]);
                /* subscriber.complete(); */
            }, this);
            return () => {
                this._userinputhandler.unSubscribeEvent(userinputtype, evt);
            };
        });
    }
    _wrapUserInput4$(userinputtype) {
        return new Observable((subscriber) => {
            const evt = this._userinputhandler.subscribeEvent(userinputtype, (value1, value2, value3, value4) => {
                subscriber.next([value1, value2, value3, value4]);
                /* subscriber.complete(); */
            }, this);
            return () => {
                this._userinputhandler.unSubscribeEvent(userinputtype, evt);
            };
        });
    }
}
//# sourceMappingURL=userinputwrapper.js.map